module.exports = __webpack_public_path__ + "img/core-user.1ac401db.svg";